// bookie-charcoal-preview — bk14 "Toshbosma" preview card.
//
// Smoke-grey paper with warm-gold engraving. A thin gold border frames the
// inner charcoal card; an inline gold lithograph rosette sits in the centre,
// the names render in Cormorant Garamond, and a tight caption pairs the
// category with the date and venue.
import { Photo, type LayoutCtx } from "./_shared";

export function BookieCharcoalPreviewLayout({ names, date, venue, accent, ink, bg, font, photo }: LayoutCtx) {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: `radial-gradient(circle at 50% 0%, ${accent}25 0%, ${bg} 55%, #000 100%)`,
        padding: "5%",
        display: "flex",
      }}
    >
      <div
        style={{
          flex: 1,
          position: "relative",
          background: bg,
          color: ink,
          padding: "8%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          boxShadow: `inset 0 0 0 1px ${accent}55, inset 0 0 0 4px ${bg}, inset 0 0 0 5px ${accent}33`,
        }}
      >
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 7,
            fontWeight: 700,
            letterSpacing: "0.4em",
            color: accent,
            marginBottom: "5%",
          }}
        >
          TAKLIFNOMA
        </div>

        {/* Gold lithograph rosette */}
        <div style={{ width: "60%", aspectRatio: "1 / 1", marginBottom: "5%", position: "relative" }}>
          <Photo
            src={photo}
            style={{ position: "absolute", inset: "10%", borderRadius: "50%" }}
            fallback={
              <svg viewBox="0 0 100 100" style={{ width: "100%", height: "100%", display: "block" }}>
                <circle cx="50" cy="50" r="46" fill="none" stroke={accent} strokeWidth="0.5" opacity="0.7" />
                <circle cx="50" cy="50" r="40" fill="none" stroke={accent} strokeWidth="0.3" opacity="0.4" />
                {/* Engine-turned guilloché */}
                <g fill="none" stroke={accent} strokeWidth="0.35" opacity="0.7">
                  {Array.from({ length: 24 }).map((_, i) => (
                    <ellipse
                      key={i}
                      cx="50"
                      cy="50"
                      rx="32"
                      ry="14"
                      transform={`rotate(${(i * 360) / 24} 50 50)`}
                    />
                  ))}
                </g>
                {/* Central rosette */}
                <g transform="translate(50 50)" fill={accent} opacity="0.9">
                  <circle r="4" />
                  {[0, 45, 90, 135, 180, 225, 270, 315].map((d) => (
                    <path key={d} d="M0 -8 L 1.6 -4 L 0 -2 L -1.6 -4 Z" transform={`rotate(${d})`} />
                  ))}
                </g>
              </svg>
            }
          />
        </div>

        <div style={{ fontFamily: font, fontSize: 30, lineHeight: 1.05, color: ink }}>
          {names}
        </div>

        <div style={{ flex: 1 }} />

        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6.5,
            fontWeight: 700,
            letterSpacing: "0.32em",
            color: accent,
            marginTop: "4%",
          }}
        >
          TAKLIFNOMA · {date}
        </div>
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6,
            fontWeight: 600,
            letterSpacing: "0.28em",
            color: `${ink}99`,
            marginTop: 6,
          }}
        >
          {venue.toUpperCase()}
        </div>
      </div>
    </div>
  );
}
